"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
const contractor_1 = require("services/master-data/contractor");
const hauler_1 = require("services/master-data/hauler");
const hauler_types_1 = require("./hauler.types");
const getDataGrid = (dataState) => (dispatch) => __awaiter(void 0, void 0, void 0, function* () {
    const response = yield (0, hauler_1._getMasterHauler)(dataState);
    if (response.isError) {
        const payload = {
            errorCode: response.errorCode,
            errorMessage: response.errorMessage,
            isError: response.isError
        };
        dispatch({ type: hauler_types_1.haulerTypes.SET_ERROR, payload });
    }
    else {
        const payload = {
            count: response.countData,
            dataGrid: response.isError ? [] : response.data.map(item => {
                return Object.assign(Object.assign({}, item), { created_date: new Date(item.created_date), modified_date: new Date(item.modified_date), status: item.is_active ? 'Active' : 'Inactive' });
            })
        };
        dispatch({ type: hauler_types_1.haulerTypes.SET_DATA_GRID, payload });
    }
});
const onDataStateChange = (dataStates) => (dispatch) => __awaiter(void 0, void 0, void 0, function* () {
    const res = yield (0, hauler_1._getMasterHauler)(dataStates);
    const payload = {
        dataGrid: res.isError ? [] : res.data.map(item => {
            return Object.assign(Object.assign({}, item), { created_date: new Date(item.created_date), modified_date: new Date(item.modified_date) });
        }),
        dataStates
    };
    dispatch({ type: hauler_types_1.haulerTypes.ON_PAGE_CHANGE, payload });
});
const onClickMutation = (payload) => dispatch => {
    dispatch({ type: hauler_types_1.haulerTypes.ON_MUTATION_CLICK, payload });
};
const onSaveDataItem = payload => (dispatch) => __awaiter(void 0, void 0, void 0, function* () {
    const { mutationMode } = payload;
    const response = payload.mutationMode === 'add' ?
        yield (0, hauler_1._createHauler)({
            contractor_id: payload.dataItem.contractor.id,
            hauler_no: payload.dataItem.hauler_no,
            hauler_spec: payload.dataItem.hauler_spec,
            is_active: payload.dataItem.is_active.value
        }) :
        yield (0, hauler_1._editHauler)({
            id: payload.dataItem.id,
            contractor_id: payload.dataItem.contractor.id,
            hauler_no: payload.dataItem.hauler_no,
            hauler_spec: payload.dataItem.hauler_spec,
            is_active: payload.dataItem.is_active.value,
            rfid_tag: payload.dataItem.rfid_tag
        });
    const dataItem = Object.assign(Object.assign({}, payload.dataItem), { id: response.data.id });
    const isSuccess = !response.isError;
    if (isSuccess) {
        dispatch({ type: hauler_types_1.haulerTypes.ON_SAVE_DATAITEM, payload: Object.assign(Object.assign({}, payload), { dataItem, mutationMode, isSuccess }) });
    }
    else {
        dispatch({ type: hauler_types_1.haulerTypes.SET_ERROR, payload: Object.assign(Object.assign({}, payload), { isError: response.isError, errorCode: response.errorCode, errorMessage: response.errorMessage }) });
    }
});
const onDelete = payload => (dispatch) => __awaiter(void 0, void 0, void 0, function* () {
    const response = yield (0, hauler_1._deleteHauler)({ id: payload.dataItem.id });
    const isSuccess = !response.isError;
    if (isSuccess) {
        dispatch({ type: hauler_types_1.haulerTypes.ON_DELETE, payload: Object.assign(Object.assign({}, payload), { isSuccess }) });
    }
    else {
        dispatch({ type: hauler_types_1.haulerTypes.SET_ERROR, payload: Object.assign(Object.assign({}, payload), { isError: response.isError, errorCode: response.errorCode, errorMessage: response.errorMessage }) });
    }
});
const getDetail = () => (dispatch) => __awaiter(void 0, void 0, void 0, function* () {
    const response = yield (0, contractor_1._getDropdownMasterContractorCoalHauling)();
    const dataContractor = response.data;
    dispatch({ type: hauler_types_1.haulerTypes.GET_DETAIL, payload: dataContractor });
});
const onFilterChange = payload => dispatch => {
    dispatch({ type: hauler_types_1.haulerTypes.ON_FILTER_CHANGE, payload });
};
const onSortChange = payload => dispatch => {
    dispatch({ type: hauler_types_1.haulerTypes.ON_SORT_CHANGE, payload });
};
const toggleError = payload => dispatch => {
    dispatch({ type: hauler_types_1.haulerTypes.SET_ERROR, payload });
};
const onLoading = () => dispatch => {
    dispatch({ type: hauler_types_1.haulerTypes.SET_LOADING, payload: true });
};
exports.default = {
    getDataGrid,
    onDataStateChange,
    onClickMutation,
    onSaveDataItem,
    onDelete,
    getDetail,
    onFilterChange,
    onSortChange,
    toggleError,
    onLoading
};
